import usePDPContext from './usePDPContext';

const DEFAULT_VALUE = {};

const usePDPStockAvailability = () =>
  usePDPContext()?.stockAvailability ?? DEFAULT_VALUE;

export default usePDPStockAvailability;
